import {PractitionerSummary} from "./practitionerSummary.model";

export class Practitioner{
    summary: PractitionerSummary;
}

export const PRACTITIONER_PARTNER_TYPE = 'PARTNER_TYPE_PRACTITIONER';
export const PARTNER_ADDITIONAL_PROPERTY_PRACTITIONER_TYPE_VALUE = 'PRACTITIONER_TYPE_VALUE';